const TextConstants = {
  PortalNames: {
    ChinoCloud: 'Chino Cloud',
    MZCloud: 'MZ Cloud',
  },
  Common: {
    TermsOfService: '利用規約',
    User: 'ユーザ',
    Group: 'グループ',
    Receiver: '受信器',
    Logger: 'ロガー',
    ID: 'ID',
    ChannelID: 'チャンネルID',
    AddChannel: 'チャンネルを追加',
    EditChannel: 'チャンネルを編集',
    AddDevice: 'デバイス追加',
    AddingDevice: 'デバイス追加',
    UngroupDevice: 'ロガーをグループから削除',
    DeleteDevice: 'デバイスの削除',
    DeletingDevice: 'デバイス削除',
    DeleteChannel: 'チャンネル削除',
    EndTime: '終了時間',
    PleaseSelectABC: '{item}を選択してください',
    PleaseSelectReceiver: '受信器を選択してください',
    Current: '現在',
    New: '新しい',
    SelectImage: '画像選択',
    Settings: '設定',
    DeleteImage: '画像削除',
    SeeCurrentImage: '現在の画像を見る',
    PleaseSelectDeviceDateRange: 'デバイス ID と日付範囲を選択してください',
    Change: '変更',
    Download: 'ダウンロード',
    ChangeDataFrame: 'データ フレームの変更',
    DataType: 'データタイプ',
    RawData: '生データ',
    HourlyAggregatedData: '時間別集計データ',
    DailyAggregatedData: '日次集計データ',
    FileSizeLimitErrorMessage: 'ファイルサイズは3MB制限があります。',
    FileFormatErrorMessage:
      'ファイル形式はJPG、PNGなどになりますので、ご注意ください。',
    From: 'から',
    To: 'の',
    NoDeviceSelected: 'デバイスが選択されていません',
    DownloadCSV: 'CSVダウンロード',
    PlotData: 'データをプロット',
    Type: 'タイプ',
    Timestamp: 'タイムスタンプ',
    Data: 'データ',
    Search: '検索',
    Logout: 'ログアウト',
    Channels: 'チャンネル',
    NoImage: '画像なし',
    NoGroup: 'グループなし',
    View: 'ビュー',
    DataUnit: 'データユニット',
    NoName: '[名称なし]',
    RegisteredUsers: '登録ユーザ',
    CompanyID: '会社ID',
    CompanyName: '会社名',
    Email: 'メール',
    AddUser: 'ユーザ追加',
    ProvisionallyUsers: '暫定ユーザ',
    FrontEnd: 'FE',
    BackEnd: 'BE',
    loggedOutSuccessfully: '正常にログアウトしました',
    ArsCloudLogin: 'Chino Cloudログイン',
    ValueType: '値のタイプ',
    Actions: 'アクション',
    Add: '追加',
    Cancel: 'キャンセル',
    Close: '閉じる',
    Delete: '削除',
    DontHavePermissionToEdit: '編集する権限がありません',
    DontHavePermissionToDelete: '削除する権限がありません',
    Edit: '編集',
    EmailFieldWarning: '有効なメールアドレスを入力してください',
    EmptyFieldWarning: '入力が必要です',
    DeleteDeviceChannelWarning:
      'すべてのダッシュボードコントロールが削除されます。',
    OK: 'OK',
    Password: 'パスワード',
    PleaseChoose: '--- 選択 ---',
    RolesConst: {
      SUPER_ADMIN: 'SUPER_ADMIN',
      COMPANY_ADMIN: 'COMPANY_ADMIN',
      DEVICE_ADMIN: 'DEVICE_ADMIN',
      STORE_ADMIN: 'STORE_ADMIN',
      GENERAL_USER: 'GENERAL_USER',
    },
    RolesName: {
      SUPER_ADMIN: 'システム管理者',
      COMPANY_ADMIN: '会社管理者',
      DEVICE_ADMIN: 'デバイス管理者',
      STORE_ADMIN: 'ストア管理者',
      GENERAL_USER: '一般ユーザ',
    },
    Username: 'ユーザ名',
    SavingSettings: '設定を保存します',
    DashboardSettingsHasBeenUpdatedSuccessfully:
      'ダッシュボードの設定が正常に更新されました',
    SavingSuccessfully: '保存しました',
    FailToUpdateDashboardSettings: 'ダッシュボードの設定を更新できませんでした',
    SavingFailed: '保存が失敗しました',
    LoadingSettings: 'ロード設定',
    DashboardSettings: 'ダッシュボード設定',
    Control: 'コントロール',
    LockControl: 'コントロールをロック',
    EditControl: 'コントロールを編集',
    FullScreen: '全画面表示',
    AddControl: 'コントロールを追加',
    NameRequired: '名前が必要です',
    MaxCharacterName: '最大の長さは{length}/30文字です',
    TypeRequired: 'タイプが必要です',
    UnitRequired: 'デバイスが必要です',
    ChannelRequired: 'チャンネルが必要です',
    PriorityRequired: '優先度が必要です',
    FontSizeRequired: '文字サイズが必要です',
    AddNewControl: '新しいコントロールを追加',
    Name: '名前',
    EntityName: '名称',
    ControlType: 'コントロールタイプ',
    Color: '色',
    Store: 'ストア',
    Device: 'デバイス',
    Channel: 'チャンネル',
    ChannelName: 'チャンネル名',
    Priority: '優先度',
    PriorityHelpText:
      '優先度の高いコントロールが重なる場合、優先度の低いコントロールの上に配置されます',
    Value: '値',
    Time: 'Time',
    NoDataTimeRange: '時間範囲にデータがありません',
    NoDataTimeRangeSelected:
      '選択したチャネルの選択した時間範囲にデータがありません',
    NumberType: 'number',
    StringType: 'string',
    BooleanType: 'boolean',
    NoData: 'データなし',
    TimeStamp: 'タイムスタンプ',
    PointType: 'ポイント値',
    GraphType: 'グラフ',
    LampType: 'ランプ',
    PinType: 'ピン',
    TableType: 'テーブル',
    SetDestination: '行き先を設定する',
    AddedSuccessMessage: '{item} が正常に追加されました',
    EditedSuccessMessage: '{item} が正常に編集されました',
    DeletedSuccessMessage: '{item} が正常に削除されました',
    Success: '成功',
    Warning: '注意',
    Failed: '失敗',
    DeleteConfirmation: '削除の確認',
    DeleteConfirmMessage: 'この {item} を削除してもよろしいですか?',
    Width: '幅',
    Height: '高さ',
    TimeFrame: '時間範囲',
    Minutes: '分',
    Image: '画像',
    Images: '画像',
    Login: 'ログイン',
    LoginPage: 'ログイン画面',
    LastConnected: '最新接続',
    Home: 'ホーム',
    EmailRequest: '登録したメールアドレスを入力',
    PleaseWait: 'お待ちください...',
    Submit: '送信',
    PasswordFieldWarning: 'パスワードが必須です',
    ConfirmPasswordFieldWarning: '確認パスワードが必須です',
    EnterPassword: 'パスワードを入力',
    EnterEmail: 'メールアドレスを入力',
    ExpiredLink: 'リンクの有効期限が切れています',
    RequireEmail: 'メールアドレスが必須です',
    FirstNameRequire: '名前が必須です',
    LastNameRequire: '姓が必須です',
    FirstNameRomajiRequire: '名（ローマ字入力のみ）が必須です',
    LastNameRomajiRequire: '姓（ローマ字入力のみ）が必須です',
    NotMatchPassword: 'パスワードと確認用パスワードが一致しません',
    EnterNewEmail: '新しいメールを入力',
    EnterFirstName: '名を入力',
    EnterLastName: '姓を入力',
    EnterFirstNameRomaji: '名を入力（ローマ字表記）',
    EnterLastNameRomaji: '姓を入力（ローマ字表記）',
    EnterNewPassword: '新しいパスワードを入力',
    EnterConfirmPassword: '確認用パスワードを入力',
    ConfirmPassword: 'パスワードを確認',
    FontSize: '文字サイズ （px）',
    IsShowDateTime: '取得日時',
    Loading: '読み込み中',
    DeviceNotRegistered: '登録されていないデバイス: ',
    ConsentToThePrivacyPolicy: '個人情報保護方針への同意必須。',
    EmailSentSuccessfullyMsg: 'メール送信に成功！',
    AddNewDevice: '新しいデバイスを追加',
    LatestConnection: '最新接続',
    MaxLengthWarningMessage: '最大の長さは{max}文字です',
    Certificate: '証明書',
    CertificateDownloadWarning:
      'ゲートウェイ作成の成功次第、証明書発行します。',
    NotAllowed: '許可しない',
    Error: 'エラー',
    OnAndOffColorShouldBeDifferent: '同色に設定不可能です',
    DateRange: '日付範囲',
    TimeRange: '時間範囲',
    EnterAtLeastOneCharacter: '少なくとも1文字以上入力してください。',
    SetFontSizeTo: '文字サイズは',
    OrMore: '以上で設定してください',
    OrLess: '以下で設定してください',
    SetThePriority: '優先度は',
    BetweenTheRange: 'の範囲で設定してください',
    EnterThePriorityAsAnInteger: '優先度は整数で入力してください。',
    EnterTheFontSizeAsAnInteger: '文字サイズは整数で入力してください。',
    TheClosestValuesAre: '最も近い値は',
    And: 'と',
    Desu: 'です',
    PasswordMustBeAtLeast8Characters:
      'パスワードは８文字以上である必要があります',
    ThisDeviceDoesntHaveAnyChannel: '選択されたデバイスには、',
    ConfiguredAsNumberType: 'タイプとして設定されたチャンネルがありません',
    SessionExpired:
      'セッションの有効期限が切れました。再度ログインしてください。',
    ColumnSettings: 'カラム設定',
    ColumnName: 'カラム名',
    Checkbox: 'チェックボックス',
    Reset: 'リセット',
    ClearFilters: 'フィルターをクリア',
    MZGateway: 'リアルタイム無線ロガー　MZ',
    ON: 'ON',
    OFF: 'OFF',
    SensorUnit: {
      Temperature: '℃',
      Humidity: '%RH',
      Pt100: '℃',
      Voltage: 'V',
      Pulse: 'cnt',
    },
    Hours: '時',
    Minutes: '分',
    NoJudgment: '判定無し',
    Time3Hours: '3時間',
    Time6Hours: '6時間',
    Time12Hours: '12時間',
    Time1Day: '1日',
    Time2Days: '2日',
    Time3Days: '3日',
    Custom: 'カスタム',
    InvalidInput: '無効な入力。',
    None: 'なし',
    SelectStore: 'ストアを選択',
    SelectGroup: 'グループを選択',
    TimeRangeValidationErrorMessage:
      '終了日時は開始日時以降の日時を設定してください',
    ScreenUpdateCommunicationFailed: '画面更新の通信に失敗しました。',
    AbnormalMeasurements: {
      '-2099': '断線',
      '-2098': '短絡',
      '-2097': '↑↑↑',
      '-2096': '↓↓↓',
    },
    OneMonthTimeRangeMessage: '日時は1ヵ月以内で指定してください',
    ScreenUpdateDataFailed: '画面更新の通信に失敗しました。',
    RegisteredNumbers: '台数登録済み',
    CannotSetTheValueLessThanRegisteredDevices:
      '登録済みのデバイス数より少ない値を設定することはできません。',
    ThisUserAlreadyExistAndCanBeUse:
      'このユーザは既に存在します。すぐにご利用いただけます。',
    FileExpired: 'ファイルの有効期限が切れました',
  },
  AlarmFlushingSettings: {
    Title: '警報フラッシングの設定',
    OnForAllAlarms: 'ON(全警報)',
    OnExceptPowerOutageAlarms: 'ON(停電警報以外)',
    Off: 'OFF',
    AlarmSound: '警報音',
    AlarmStops: '警報停止',
    DoYouWantToStopAlarmFlashing: '警報フラッシングを停止しますか？',
  },
  UsersManagement: {
    Title: 'ユーザ管理',
    MZTitle: 'ユーザ管理',
    AddUser: 'ユーザ追加',
    CancelChangePassword: 'パスワード変更をキャンセル',
    ChangePassword: 'パスワード変更',
    CompanyName: '会社名',
    DepartmentName: '部門名',
    Email: 'メール',
    FirstName: '名',
    LastName: '姓',
    FirstNameRomaji: '名（ローマ字入力のみ）',
    LastNameRomaji: '姓（ローマ字入力のみ）',
    GeneralUser: '一般ユーザ',
    Roles: '役割',
    StoreName: 'ストア名',
    UsersManagement: 'ユーザ管理',
    ForgotPassword: 'パスワードを忘れた方',
    ResetPassword: 'パスワードリセット',
    Register: '登録',
    Login: 'ログイン',
    SuperAdmin: 'スーパー管理者',
    CompanyAdmin: '会社の管理者',
    StoreAdmin: 'ストア管理者',
    PasswordWarningMessage:
      'パスワードは長さが8~99文字で、数字、特殊文字、英大文字、英小文字のそれぞれを最低1文字ずつ含む必要があります',
    RomajiWarningMessage: '全てローマ字表記にする必要があります。',
    CompanyNameMessage: '半角英数および「. - &」記号で入力してください。',
    Reset: 'リセット',
    // CompanyAdminOnly: '会社の管理者のみ',
    // CompanyAndAdmin: '会社と管理者',
    CompanyType: { Merchandise: 'MZ商品', General: '一般' },
    StoreAdminOnly: 'ストア管理者のみ',
    StoreAndAdmin: '新しいストアと管理者',
    DisplayName: '表示名',
    DeleteUser: 'ユーザを削除します',
    DeleteUserConfirmationMessage: 'こちらのユーザを削除しますか？',
    userNo: 'ユーザNo',
    UserDetails: {
      Title: 'ユーザ詳細',
      Limit: '制限',
      ReceiverLimit: 'ゲートウェイ制限',
      LoggerLimit: 'ロガー制限',
      Feature: '機能',
      Accessable: 'アクセス可能',
      UserTier: 'ユーザティア',
      TierTexts: {
        FREE: '無料',
        PAID: '有料',
        CUSTOM: 'カスタム',
      },
      UpdateSettingsSuccessfully: '設定の更新に成功しました',
      ApiKeysEnabled: 'APIキー管理',
    },
  },
  StoresManagement: {
    Title: 'ストア管理',
    Stores: 'ストア',
    AddStore: 'ストア追加',
    EditStore: 'ストア編集',
    DeleteStore: 'ストア削除',
    StoreName: 'ストア名',
  },
  GroupsManagement: {
    Title: 'グループ管理',
    Groups: 'グループ',
    AddGroup: 'グループ追加',
    EditGroup: 'グループ編集',
    EditGroupName: 'グループ名称編集',
    DeleteGroup: 'グループ削除',
    GroupName: 'グループ名称',
    StoreList: 'ストア',
    GroupDevices: {
      Title: 'ロガー編集',
      DeviceId: 'ロガーID',
      DeviceName: 'デバイス名',
      AddLogger: 'ロガー追加',
      LoggerIDOrName: 'ロガーID|ロガー名称',
      AddGroupLoggerSuccessMessage: 'ロガーが正常に追加されました',
      UnlinkGroupLoggerMessage: 'このロガーをグループから除外しますか？',
      UnlinkGroupLoggerSuccessMessage: 'ロガーが正常に削除されました',
    },
    GroupStores: {
      Title: 'グループの詳細',
      DeviceName: 'デバイス名',
      AccessLevel: '許可レベル',
    },
  },
  ReceiversManagement: {
    Title: '受信器一覧',
    Receivers: 'レシーバー',
    No: 'No',
    ReceiverId: '受信器ID',
    Name: '受信器名称',
    LastUpdated: '最終更新日時',
    NumOfConntectedDevices: '接続台数',
    PowerStatus: '電源ステータス',
    ReceiverError: '異常情報',
    ReceiverErrorTooltipMsg:
      '(計測値の異常(位置情報)、データベース異常、設定ファイル異常、時計情報異常、その他機器異常)、(内蔵充電池駆動、シャットダウン開始)',
    DeviceErrorTooltipMessages: {
      1: '計測値の異常(位置情報)',
      2: 'データベース異常',
      3: '設定ファイル異常',
      4: '時計情報異常',
      5: 'その他機器異常',
    },
    PowerErrorTooltipMessages: {
      1: '内蔵充電池駆動',
      2: 'シャットダウン開始',
    },
    ErrorEquipment: '機器',
    ErrorPowerSupply: '電源',
    WirelessCommunicationCycle: '無線通信周期',
    DataTransferCycle: 'データ転送周期',
    ReceiverInformationCycle: 'ステータス通信周期',
    GPSCycle: 'GPS取得周期',
    ReceiverType: '機種',
    FirmwareVersion: 'バージョン',
    WirelessIPAddresses: 'ワイヤレスIPアドレス',
    WiredIPAddresses: '有線IPアドレス',
    WirelessLANIPAddress: '無線LAN IPアドレス',
    WiredLANIPAddress: '有線LAN IPアドレス',
    GPSStatus: 'GPSステータス',
    LTESignalStrength: 'LTE電波強度',
    Coordinates: '座標',
    GPSReceptionStatus: 'GPS受信状態',
    None: '無し',
    WirelessCommunicationCycles: {
      0: '設定無し',
      1: '10秒',
      2: '20秒',
      3: '1分',
      4: '5分',
      5: '10分',
      6: '15分',
      7: '20分',
      8: '30分',
      99: '高速通信',
    },
    NoSetting: '設定無し',
    HighSpeedCommunication: '高速通信',
    Time10Seconds: '10秒',
    Time20Seconds: '20秒',
    Time30Seconds: '30秒',
    Time1Min: '1分',
    Time3Mins: '3分',
    Time5Mins: '5分',
    Time10Mins: '10分',
    Time15Mins: '15分',
    Time20Mins: '20分',
    Time30Mins: '30分',
    Time1Hour: '1時間',
    Time2Hours: '2時間',
    Time3Hours: '3時間',
    Time6Hours: '6時間',
    Time12Hours: '12時間',
    Time24Hours: '24時間',
    ReceiverModel: {
      MZG10: 'MZ-G10',
      MZG00: 'MZ-G00',
    },
    OutOfService: '圏外',
    Weak: '弱',
    Medium: '中',
    Strong: '強',
    DeleteReceiver: '受信器削除',
    PleaseSelectAReceiver: '受信器を選択してください',
    DeleteReceiverMessage:
      'この受信器を削除してもよろしいですか？\n削除する場合は、受信器のIDを入力してください。',
    NoRowsToShow: '表示する受信器がありません',
  },
  // "Measurement", "Battery", "Sensor", "Memory", "Device"
  // 「計測」、「電池」、「センサ」、「メモリ」、「機器」
  LoggersManagement: {
    Title: 'ロガー一覧',
    Loggers: 'ロガー',
    AddLogger: 'ロガーを追加する',
    LoggerId: 'ロガーID',
    LoggerName: 'ロガー名称',
    No: 'No',
    Group: 'グループ',
    MemoryError: 'メモリ異常',
    MemoryErrors: {
      1: 'メモリ',
    },
    SensorError: 'センサ異常',
    SensorErrors: {
      1: 'CH1センサ',
      2: 'CH2センサ',
      3: 'CH3センサ',
      4: 'CH1センサ/CH2センサ',
      5: 'CH1センサ/CH3センサ',
      6: 'CH2センサ/CH3センサ',
      7: 'CH1センサ/CH2センサ/CH3センサ',
    },
    OtherError: 'その他機器異常',
    OtherErrors: {
      1: '機器',
    },
    ReceiverId: '接続先受信器ID',
    ReciverName: '接続先受信器名',
    LoggerAlarm: '警報',
    LoggerAlarms: {
      2000: 'CH$CH$上上限',
      200: 'CH$CH$上限',
      2200: 'CH$CH$上限・上上限',
      20: 'CH$CH$下限',
      2: 'CH$CH$下下限',
      22: 'CH$CH$下限・下下限',
    },
    AlarmLogger: '警報',
    Sensor: 'センサ',
    AlarmLoggerType: {
      Measurement: '計測',
      bat: '電池', // Battery
      asi: 'センサ', // Sensor
      mei: 'メモリ', // Memory
      oer: '機器', // Device
    },
    Name: 'ロガー名称',
    LastUpdated: '最終更新日時', // Not used, should be remove in future
    LatestMeasurementTime: '計測日時',
    RadioWaveStrength: '電波',
    Battery: '電池',
    Measurements: '測定',
    CH1: 'CH1',
    CH2: 'CH2',
    CH3: 'CH3',
    CH4: 'CH4',
    UULAV: '上上限 警報設定値', // upper upper limit alarm value
    UULAD: '上上限 警報遅延', // upper upper limit alarm delay
    ULAV: '上限 警報設定値', // upper limit alarm value
    ULAD: '上限 警報遅延', // upper limit alarm delay
    LLAV: '下限 警報設定値', // lower lower limit alarm value
    LLAD: '下限 警報遅延', // lower lower limit alarm delay
    LLLAV: '下下限 警報設定値', // lower limit alarm value
    LLLAD: '下下限 警報遅延', // lower limit alarm delay
    SensorType: 'センサ種',
    SensorTypeTexts: {
      Temperature: '温度',
      Humidity: '湿度',
      TemperatureBuiltInSensor: '温度(センサ内蔵)',
      TemperatureExternal: '温度(外付け)',
      BuiltIinThermistor: '内蔵サーミスタ',
      ExternalThermistor: '外付けサーミスタ',
      TemperatureAndHumidity: '温湿度',
      RTD: '測温抵抗体',
      Pt100: 'Pt100',
      Voltage: '電圧',
      Pulse: 'パルス',
      KThermocouple: 'K熱電対',
      TThermocouple: 'T熱電対',
      DedicatedBtrBuiltInThermistor: '内蔵サーミスタ(専用バッテリ)',
      DedicatedBtrExternalThermistor: '外付けサーミスタ(専用バッテリ)',
      DedicatedBtrTemperatureAndHumidity: '温湿度(専用バッテリ)',
      DedicatedBtrResistanceTemperatureDetector: '測温抵抗体(専用バッテリ)',
      DedicatedBtrVoltage: '電圧(専用バッテリ)',
      DedicatedBtrPulse: 'パルス(専用バッテリ)',
      DedicatedBtrKThermocouple: 'K熱電対(専用バッテリ)',
      DedicatedBtrTThermocouple: 'T熱電対(専用バッテリ)',
    },
    LoggerSoftwareVersion: 'バージョン',
    SettingChangeTime: '設定変更日時',
    RadioCommunicationTime: '無線通信日時',
    RecordingCycle1: '計測周期',
    RecordingCycle2: '警報監視周期',
    Events: 'イベント',
    LoggerConnectionTime: '接続日時',
    LoggerDisconnectionTime: '切断日時',
    WirelessCommunicationTime: '無線通信日時',
    None: '無し',
    Time5Seconds: '5秒',
    Time10Seconds: '10秒',
    Time20Seconds: '20秒',
    Time30Seconds: '30秒',
    Time1Min: '1分',
    Time3Mins: '3分',
    Time5Mins: '5分',
    Time10Mins: '10分',
    Time15Mins: '15分',
    Time20Mins: '20分',
    Time30Mins: '30分',
    Time1Hour: '1時間',
    Time2Hours: '2時間',
    Time3Hours: '3時間',
    Time6Hours: '6時間',
    Time12Hours: '12時間',
    Time24Hours: '24時間',
    DeleteLogger: 'ロガー削除',
    PleaseSelectALogger: 'ロガーを選択してください',
    DeleteLoggerMessage:
      'このロガーを削除してもよろしいですか？\n削除する場合は、ロガーのIDを入力してください。',
    NoRowsToShow: '表示するロガーがありません',
  },
  HistoryData: {
    Title: '履歴',
    Timestamp: '日時',
    RecordingEquipment: '記録機器',
    RecordingDeviceId: '記録機器ID',
    DeviceName: '記録機器名称',
    Operator: '操作者',
    OperationType: '動作種',
    Desc: '内容',
    Params: 'データ',
    Details: '詳細',
    DataFilter: 'データフィルタ',
    FetchData: 'データ取得',
    Operators: {
      0: '自動動作',
      1: 'ローカル管理者',
      2: 'ローカル一般ユーザ',
      3: {
        chino_engineering_001122: 'ローカルSV',
        chino_settinguser_009988: 'ローカルSV(Low)',
        lcSV: 'ローカルSV',
      },
      4: 'N/A',
      5: 'クラウドユーザ',
    },
    OperationTypes: {
      // receiver
      0: {
        2: '動作',
        4: '機器異常',
        5: 'イベント',
      },
      // logger
      1: {
        1: '計測警報',
        2: '機器異常',
        3: '動作',
        4: 'イベント',
      },
    },
    EquipmentTypes: {
      0: '受信器',
      1: 'ロガー',
    },
    NotSpecified: '指定なし',
    SelectableOperationTypes: [
      {
        label: '動作',
        value: '動作',
      },
      {
        label: '計測警報',
        value: '計測警報',
      },
      {
        label: '機器異常',
        value: '機器異常',
      },
      {
        label: 'イベント',
        value: 'イベント',
      },
    ],
    NoHistoryToDisplay: '表示する履歴がありません',
    NoHistoryToExport: '出力する履歴がありません',
  },
  CSVData: {
    Timestamp: '日時',
    FlagDisplaySettings: 'フラグの表示設定',
    DisplayEvents: 'イベントの表示',
    DisplayDeviations: '逸脱の表示',
    DisplayAlarms: '警報の表示',
    GPSDisplaySettings: 'GPSの表示設定',
    DisplayGPS: '表示',
    OutputFormat: '出力フォーマット',
    AssignEachLogger: '時間軸をロガーごとに付与',
    UnifyIntoOne: '時間軸を1つに統一',
    TimeInterval: '時間間隔',
    Interval: '間隔',
    FetchData: 'データ取得',
    ExportCSV: 'CSV出力',
    // table columns
    Title: 'CSV出力',
    LoggerName: 'ロガー名称',
    LoggerId: 'ロガー ID',
    SensorName: 'センサ ',
    SensorType: 'センサ種',
    Group: 'グループ',
    OldestDataTime: '最古データ日時',
    LatestDataTime: '最新データ日時',
    NumberRecords: '計測データ数',
    // messages
    PleaseSelectRecordsToDownload: 'ダウンロードするレコードを選択してください',
    PleaseSelectLogger: 'ロガーを選択してください',
    ExceedMaximumSelectableDevices:
      '選択可能なデバイスの最大数を超えました。最初の$maximum$件が選択されます。再度ダウンロードボタンをクリックして処理を開始してください。',
    NoRowsToShow: '表示するロガーがありません',
  },
  TrendGraph: {
    Timestamp: '日時',
    NoDeviceSelected: 'デバイスを選択してください',
    NoLoggerSelected: 'ロガーを選択してください',
    NoChannelSelected: 'チャンネルを選択してください',
    FlagDisplaySettings: 'フラグの表示設定',
    DisplayEvents: 'イベントの表示',
    DisplayDeviations: '逸脱の表示',
    DisplayAlarms: '警報の表示',
    GPSDisplaySettings: 'GPSの表示設定',
    DisplayGPS: '表示',
    OutputFormat: '出力フォーマット',
    AssignEachLogger: '時間軸をロガーごとに付与',
    UnifyIntoOne: '時間軸を1つに統一',
    Interval: '間隔',
    FetchData: 'データ取得',
    ExportCSV: 'CSV出力',
    // table columns
    Title: 'トレンドグラフ',
    LoggerName: 'ロガー名称',
    LoggerId: 'ロガー ID',
    SensorType: 'センサ種 ',
    SensorName: 'センサ ',
    GroupName: 'グループ名',
    OldestDataTime: '最古データ日時',
    LatestDataTime: '最新データ日時',
    NumberRecords: '計測データ数',
    // messages
    PleaseSelectRecordsToDownload: 'ダウンロードするレコードを選択してください',
    ExceedMaximumSelectableDevices:
      '選択可能なデバイスの最大数を超えました。最初の$maximum$件が選択されます。再度ダウンロードボタンをクリックして処理を開始してください。',
    ExceedMaximumSelectableTimeRange: '最大期間は$maximum$日間です。',
    GraphSettings: 'グラフ設定',
    SettingsModal: {
      Title: '設定',
      GraphMode: 'グラフモード',
    },
    DeviceId: 'ロガーID',
    DisplayChannels: 'グラフ表示',
    DataUnits: '单位',
    NumOfDataRecords: '収録データ数',
    NumOfAlarms: '警報数',
    NumOfMissingRecords: '欠損データ数',
    MaxValue: '最高値',
    MinValue: '最低値',
    AverageValue: '平均値',
    OldestDataDateTime: '開始日時',
    LatestDataDateTime: '終了日時',
    ReferenceLine: '基準線',
    PleaseInputLinesValue: '基準線の値を入力してください',
    NoLoggerToDisplay: '表示するロガーがありません',
    NoChannelDataInSpecifiedRange: '指定期間範囲内にデータが存在しません',
    TimeoutError: 'エラー：タイムアウト',
  },
  MultiGraph: {
    Title: 'データビュー',
    NoDeviceSelected: 'デバイスを選択してください',
    NoChannelSelected: 'チャンネルを選択してください',
    DateRangeError: '日時範囲は30分以上30日未満に設定してください',
    StartDateTime: '開始日時',
    EndDateTime: '終了日時',
    PlotDisplay: 'プロット表示',
    Display: 'ディスプレイ',
    NoDisplay: '表示なし',
    DisplayRangeSettings: '表示範囲',
    DeviationSettings: '偏差値設定',
    UpperLimit: '上限',
    LowerLimit: '下限',
    DeviceId: 'デバイスID',
    DisplayChannels: 'グラフ表示',
    DataUnits: '单位',
    NumOfDataRecords: '収録データ数',
    NumOfAlarms: '警報数',
    NumOfMissingRecords: '欠損データ数',
    MaxValue: '最高値',
    MinValue: '最低値',
    AverageValue: '平均値',
    OldestDataDateTime: '開始日時',
    LatestDataDateTime: '終了日時',
    NumberOfDeviations: '逸脱数',
  },
  MissingData: {
    Title: '収集データ管理',
    DisplaySettings: '表示設定',
    Debugging: 'デバッグ',
    DisplayType: '表示種別',
    MeasurementData: '計測データ',
    HistoryOfMeasurementAlarm: '計測警報履歴',
    AbnormalHistoryOfMachine: '機器異常履歴',
    ActionHistory: '動作履歴',
    EventHistory: 'イべント履歴',
    DivisionStartDateAndTime: '分割開始日時',
    DeleteDividedData: '分割したデータの削除',
    Delete: '削除する',
    DoNotDelete: '削除しない',
    SplitExecution: '分割実行',
    // Start table header
    LoggerName: 'ロガー名称',
    LoggerId: 'ロガーID',
    SensorType: 'センサ種',
    OldestDataDateTime: '最古データ日時',
    LatestDataDateTime: '最新データ日時',
    OldestMissingDataDateTime: '最古欠損データ日時',
    LatestMissingDataDateTime: '最新欠損データ日時',
    DataCount: 'データ数',
    // End table header
  },
  LastData: {
    Title: '最新データ',
  },
  Dashboard: {
    Title: 'ダッシュボード',
    ControlAdded: 'コントロールが正常に追加されました。',
    ControlUpdated: 'コントロールが正常に更新されました。',
    ControlDeleted: 'コントロールが正常に削除されました。',
    UpdatePositionOrSizeFailedErrMsg:
      'コントロールの位置またはサイズを更新できませんでした',
    SetPinPositionFailedErrMsg: 'ピン位置の設定に失敗しました',
  },
  GPSDashboard: {
    Title: 'GPSマップ',
    SensorMapDetail: 'センサー詳細',
    SearchDevices: '機器を探す',
    NumberOfDevicesDisplaying: '表示機器数: ',
    GPS: 'GPS: ',
    Temperature: '温度: ',
    TemperatureUnit: '°C',
    Condition: '状態: ',
    Power: '電源: ',
    GoToDetailScreen: '詳細画面へ',
    SensorStatus: {
      TemperatureWarning: '温度警告',
      Normal: '正常',
    },
    DetailOfItem: '{item}の詳細',
    TimeRangeSelector: '時間範囲セレクター',
    InvalidDateRangeMsg: '開始時間は終了時間より前に設定してください',
    TheMaximumIsThreeDaysMsg: '上限は3日間です。',
    TheMaximumIsTenDaysMsg: '上限は10日間です。',
  },
  DataView: {
    Title: 'データビュー',
    NoDeviceSelected: 'デバイスを選択してください',
    NoChannelSelected: 'チャンネルを選択してください',
    RawDataDateRangeError: '日時範囲は30分以上6時間未満に設定してください',
    HourlyDataDateRangeError: '日付範囲は1日以上1年未満に設定してください',
    DailyDataDateRangeError: '日付範囲は1日以上5年未満に設定してください',
    EndpointTimeOutError:
      '取得するデータが多すぎます。データ取得範囲を狭めるか、チャンネル数を減らしてください。',
    Average: '平均値',
    Minimum: '最小値',
    Maximum: '最大値',
    Date: '日付',
  },
  DeviceSettings: {
    Title: 'デバイス設定',
    EditDevice: 'デバイスを編集：',
  },
  GatewaySettings: {
    GatewayLabel: 'ゲートウェイ',
    Title: 'ゲートウェイ設定',
    GatewayID: 'ゲートウェイID',
    GatewayName: 'ゲートウェイ名',
    AddNewGateway: '新しいゲートウェイを追加：',
    DeleteGateway: 'ゲートウェイを削除：',
    EditGateway: 'ゲートウェイを編集：',
  },
  ChannelSettings: {
    Title: 'チャンネル設定',
  },
  Permissions: {
    READ_WRITE: 'Read Write',
    READ_ONLY: 'Read Only',
  },
  Register: {
    TermsOfUse: 'サービス利用規約',
    PrivacyPolicy: 'プライバシーポリシー',
    Agree: 'に同意します。',
    AcceptAllTermsOfUse: '利用規約に同意します。',
  },
  ApiKeysManagement: {
    Title: 'APIキー管理',
    ApiKey: 'APIキー',
    CreateApiKey: 'APIキー作成',
    KeyName: 'キー名',
    Company: '会社',
    CompanyId: '会社ID',
    Permissions: '権限',
    Status: 'ステータス',
    Created: '作成日時',
    LastUsed: '最終使用',
    Expires: '有効期限',
    Actions: '操作',
    Active: '有効',
    Revoked: '無効',
    Never: 'なし',
    IncludeRevoked: '無効化されたキーを含む',
    SelectCompany: '会社を選択',
    AllCompanies: '全ての会社',

    // Permissions
    PermissionReceivers: '受信器ステータス',
    PermissionLoggers: 'ロガーステータス',
    PermissionMeasurements: 'ロガー計測値',
    PermissionHistory: '履歴',

    // Create Modal
    CreateTitle: 'APIキー作成',
    KeyNamePlaceholder: 'キーの用途を入力',
    ExpirationOptional: '有効期限（オプション）',

    // Success Messages
    KeyCreatedTitle: 'APIキーが作成されました',
    KeyCreatedWarning:
      'このキーは一度しか表示されません。安全な場所にコピーしてください。',
    CopyToClipboard: 'コピー',
    Copied: 'コピーしました',
    RevokeSuccess: 'APIキーが無効化されました',

    // Update Modal
    UpdateTitle: 'APIキー編集',

    // Revoke Modal
    RevokeTitle: 'APIキーを無効化',
    RevokeConfirmation:
      'このAPIキーを無効化しますか？このキーを使用しているアプリケーションは即座にアクセスできなくなります。',
    RevokeButton: '無効化',

    // Delete Modal
    DeleteTitle: 'APIキーを削除',
    DeleteConfirmation:
      'このAPIキーを完全に削除しますか？この操作は取り消せません。',
    DeleteButton: '削除',

    // Validation
    CompanyRequired: '会社を選択してください',
    KeyNameRequired: 'キー名を入力してください',
    KeyNameMaxLength: '最大128文字まで入力可能です',
    PermissionsRequired: '少なくとも1つの権限を選択してください',
    ExpirationMustBeFuture: '有効期限は未来の日付を指定してください',

    // Fields
    ExpirationDate: '有効期限',

    // Errors
    CreateError: 'APIキーの作成に失敗しました',
    UpdateError: 'APIキーの更新に失敗しました',
    RevokeError: 'APIキーの無効化に失敗しました',
    DeleteError: 'APIキーの削除に失敗しました',
    TotalApiKeys: '登録したAPIキー：',
    MaxApiKeysReached: '登APIキーの登録数は最大20個までに制限です'
  },
};

export default TextConstants;
